/**
 * @packageDocumentation
 * @module      IpAddressMap.ts
 * @description Maps device types to their IP addresses.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class IpAddressMap {
    /**
     * Return the IP address for the device, or an empty string if the deviceType is unknown.
     * @param deviceType
     */
    static getIpAddress(deviceType) {
        switch (deviceType) {
            case "CSUI":
                return '192.168.7.30';
            case "CSIC":
                return '192.168.7.20';
            case "CSRC":
                return '192.168.7.10';
            case "PSUI":
                return '192.168.6.30';
            case "PSIC":
                return '192.168.6.20';
            case "PSRC":
                return '192.168.6.10';
            default:
                return '';
        }
    }
}
//# sourceMappingURL=IpAddressMap.js.map